"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createTournament: function() {
        return createTournament;
    },
    deleteTournament: function() {
        return deleteTournament;
    },
    generateTournaments: function() {
        return generateTournaments;
    },
    resetTournaments: function() {
        return resetTournaments;
    },
    updateTournament: function() {
        return updateTournament;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createTournament(payload) {
    return {
        type: _types.ADD_TOURNAMENT,
        payload
    };
}
function updateTournament(payload) {
    return {
        type: _types.UPDATE_TOURNAMENT,
        payload
    };
}
function deleteTournament(payload) {
    return {
        type: _types.DELETE_TOURNAMENT,
        payload
    };
}
function resetTournaments() {
    return {
        type: _types.RESET_TOURNAMENTS
    };
}
function generateTournaments(payload) {
    return {
        type: _types.GENERATE_TOURNAMENTS,
        payload
    };
}
